export {default as AcceptDeclineBanner} from './AcceptDeclineBanner.connect';
